import * as types from '../constants';

const initialState = {
  bookingListTotal: 0,
  bookingListItems: [],
  viewType: 'table',
  currentPageNumber: 1,
  paginationItem: {
    offset: 0,
    limit: 10,
  },
  sortItem: {
    sort: '',
    order: '',
  },
  filterItem: {
    buildingId: '',
    roomName: '',
    phoneNumber: '',
    startAt: '',
    endAt: '',
  },
};

const BookingListReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.INIT_BOOKING_LIST_STATE:
      return {
        ...state,
        bookingListTotal: 0,
        bookingListItems: [],
        viewType: 'table',
        currentPageNumber: 1,
        paginationItem: {
          offset: 0,
          limit: 10,
        },
        sortItem: {
          sort: '',
          order: '',
        },
        filterItem: {
          buildingId: '',
          roomName: '',
          phoneNumber: '',
          startAt: '',
          endAt: '',
        },
      };
    case types.SET_VIEW_TYPE:
      return {
        ...state,
        viewType: action.payload,
      };
    case types.SET_BOOKING_LIST:
      return {
        ...state,
        bookingListTotal: action.payload.total,
        bookingListItems: action.payload.items,
      };
    case types.SET_BOOKING_LIST_CURRENT_PAGE_NUMBER:
      return {
        ...state,
        currentPageNumber: action.payload,
      };
    case types.SET_BOOKING_PAGINATION_ITEM:
      return {
        ...state,
        paginationItem: action.payload,
      };
    case types.SET_BOOKING_SORT_ITEM:
      return {
        ...state,
        sortItem: action.payload,
      };
    case types.SET_BOOKING_FILTER_ITEM:
      return {
        ...state,
        filterItem: action.payload,
      };
    default:
      return state;
  }
};

export default BookingListReducer;